import { Formik } from "formik";
import React, { useState, useEffect, useRef } from "react";
import * as yup from "yup";
import { Col, Form, Row, Spinner, Table } from "react-bootstrap";
import Fontstyling, {
  clientListDrpDwnStyles,
} from "../../../components/common/comman";
import Required from "../../../components/Required";
import {
  GetCGTMemberID,
  GetCGTMembers,
} from "../../../api/ClinicalIntake/ClinicalIntakeApi";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ReactTooltip from "react-tooltip";
import { IoMdArrowRoundBack } from "react-icons/io";
import showmore from "../../../assets/icon/showmore.svg";
import CustomMaterialTable from "../../../components/common/CustomMaterialTable";
const stepHeaders = [
  {
    id: 1,
    title: "Clinical Intake Submitted data",
    description: "Clinical Intake and Reporting Form",
  },
  {
    id: 2,
    title: "Clinical Situation (S)",
    description:
      "Enter the clinical information associated with the Plan Insights Member diagnosis and affiliated",
  },
  {
    id: 3,
    title: "Background (B)",
    description:
      "Provide summary of findings based on reported claims in the observation period listed above",
  },
  {
    id: 4,
    title: "Assessment (A)",
    description:
      "Provide a summary of potential procedures, treatments, medications and outcomes associated with the member's claim profile",
  },
  {
    id: 5,
    title: "Recommendation (R)",
    description:
      "Provide recommendation related to plan policy, treatment review, stop loss, well-being, etc. This includes exploration of alternatives, site of care changes, white/brown bagging, forensic billing review, recovery/subrogation need, etc.",
  },
];


const SBARFormReview = () => {
  const [isPreveiw, setIsPreveiw] = useState(false);
  const [memberAllData, setMemberAllData] = useState([]);
  const [selectedCgtId, setSelectedCgtId] = useState(null);
  const [showTable,setShowTable] = useState(true)
  const [cgtIdData, setCgtIdData] = useState([]);
  const [formData, setFormData] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [witchAction, setWitchAction] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const initialValues = {
    cgT_Member_ID: "",
  };
  const column = [
    { title: "Plan Insights Member ID ", field: "CGT_MEMBER_ID", type: "text" },
    { title: "Clinical Consultant First Name", field: "CLINICAL_CONSULTANT_FIRSTNAME", type: "text" },
    { title: "Clinical Consultant Last Name", field: "CLINICAL_CONSULTANT_LASTNAME", type: "text" },
    { title: "Benefit Point ID", field: "BENEFIT_POINT_ID", type: "number" },
    { title: "Client Name", field: "CLIENT_NAME", type: "text" },
    { title: "Date Submitted", field: "DATE_SUBMITTED", type: "date" },
    {
      title: "Actions",
      minWidth: "96px",
      maxWidth: "75px",
      cellStyle: { textAlign: "center" },
      headerStyle: { textAlign: "center" },
      sorting: false,
      render: (rowData) =>
        rowData.status !== "" ? (
          <>
            <p
              width="11"
              className="m-2 cursor-pointer text-primary "
              alt="show more"
              style={{textDecoration:'underline',fontWeight:"bold"}}
              onClick={() => {
                setShowTable(false)
                setFormData(rowData);
                setWitchAction("showMore");
              }}
            >More...</p>
          </>
        ) : (
          <div className="m-2" style={{ height: "11px", width: "11px" }}></div>
        ),
    },
  ];
  const loadIdOptions1 = async (searchQuery, loadedOptions, { page }) => {
    if (searchQuery.length > 3 || searchQuery?.length === 0) {
      try {
        let response = await GetCGTMemberID(100, page, searchQuery);
        const data = await response.data;
        setCgtIdData([data]);
        // const newOptions = data.map(port => ({ label: port, value: port }));
        const newOptions = data.map((port) => ({
          value: port.PATIENT_ID,
          label: port.PATIENT_ID,
        }));
        return {
          options: newOptions,
          hasMore: newOptions.length >= 1,
          additional: {
            page: page + 1,
          },
        };
      } catch (error) {
        console.error("Error fetching data:", error);
        return {
          options: [],
          hasMore: false,
          additional: {
            page: page,
          },
        };
      }
    } else {
      return {
        options: [{ value: 0, label: "Please type at least 4 characters" }],
        hasMore: false,
        additional: {
          page: page,
        },
      };
    }
  };


  return (
    <>
      {showTable !== true  && <div
        onClick={() => setShowTable(true)}
        className="bacfkarrow"
        style={{
          position: "sticky",
          top: 0,
          cursor: "pointer",
          left: 0,
          right: 0,
          zIndex: 100,
          width: "fit-content",
          fontSize:"20px"
        }}
      >
        <IoMdArrowRoundBack />
      </div>}
      {showTable === true ?
      <>
      <div style={Fontstyling.heading}>View submitted SBAR data by typing the Plan Insights Member ID into the search box</div>
        <Formik
          enableReinitialize
          initialValues={initialValues}
        >
          {({
            values,
            setFieldValue,
            touched,
            errors,
          }) => (
            <Form >
              <Row className="mt-2">
                <Form.Group as={Col} xs={6} lg={4}>
                  <Form.Label style={Fontstyling.label}>
                  Plan Insights Member ID <Required />
                  </Form.Label>
                  <AsyncPaginate
                    id="5465f"
                    value={selectedCgtId || ""}
                    loadOptions={loadIdOptions1}
                    name="cgT_Member_ID"
                    styles={{
                      ...clientListDrpDwnStyles,
                      control: (base) => ({
                        ...clientListDrpDwnStyles.control(base),
                        border: `1px solid ${errors.cgT_Member_ID &&
                          touched.cgT_Member_ID &&
                          !values.cgT_Member_ID
                          ? "red"
                          : "lightgrey"
                          }`,
                      }),
                    }}
                    placeholder="Select Plan Insights Member ID"
                    onChange={async (option) => {
                      setIsLoading(true)
                      try {
                        setFieldValue("cgT_Member_ID", option.label);
                        setSelectedCgtId(option);
                        const response = await GetCGTMembers(option.value);
                        const data = response.data;
                        setMemberAllData(data);                       
                        setShowTable(true)
                      } catch (error) {
                        console.error("Error fetching data:", error);
                      }
                      finally{
                        setIsLoading(false)
                      }
                    }}
                    additional={{
                      page: 1,
                    }}
                    isSearchable={true}
                    isOptionDisabled={(e) => e.value === 0}
                  />
                  {errors.cgT_Member_ID &&
                    touched.cgT_Member_ID &&
                    !values.cgT_Member_ID && (
                      <p className="invalid-feedback d-block">
                        {errors.cgT_Member_ID}
                      </p>
                    )}
                </Form.Group>
              </Row>
            </Form>
          )}
        </Formik></>
        : <div
          className={
            "my-auto mx-5 pe-none pe-auto position-relative"
          }
          style={{overflowY:"scroll"}}
        >
          
          <div
            className={
              "form-section mt-3"
            }
          >
            <Form1
              formData={formData}
              setSelectedCgtId={setSelectedCgtId}
              selectedCgtId={selectedCgtId}
            />
          </div>
          <div
            className={
              "form-section mt-3"
            }
          >
            <Form2
              formData={formData}
            />
          </div>
          <div
            className={
              "form-section mt-3"
            }
            style={{ pageBreakBefore: "always" }}
          >
            <Form3
              formData={formData}
            />
          </div>
          <div
            className={
              "form-section mt-3"
            }
          >
            <Form4
              formData={formData}
            />
          </div>
          <div
            className={
              "form-section mt-3"
            }
          >
            <Form5
              isPreveiw={isPreveiw}
              setIsPreveiw={setIsPreveiw}
              formData={formData}
              setShowTable={setShowTable}
            />
          </div>
          <div
            className={"d-block"}
          >
          </div>
        </div>}
      {showTable === true && <CustomMaterialTable
        overrideColumn={column}
        data={memberAllData}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setFormData}
        isLoading={isLoading}
        isExport={false}
        isSearchRequired={'No'}
      />}
    </>
  );
};

export default SBARFormReview;

const Form1 = ({ formData,setSelectedCgtId ,selectedCgtId}) => {
  const [clientData, setClientData] = useState([]);
  const [selectedClientvalue, setSelectedClientValue] = useState(null);
  const [cgtIdData, setCgtIdData] = useState([]);

  const initialValues = {
    date_Submitted: formData?.DATE_SUBMITTED.split("T")[0],
    clinical_Consultant_FirstName: formData?.CLINICAL_CONSULTANT_FIRSTNAME,
    clinical_Consultant_LastName: formData?.CLINICAL_CONSULTANT_LASTNAME,
    benefit_Point_ID: formData?.BENEFIT_POINT_ID,
    client_Name: formData?.CLIENT_NAME,
    cgT_Member_ID: formData?.CGT_MEMBER_ID,
    member_DOB: formData?.DATE.split("T")[0],
    member_Gender: formData?.MEMBER_GENDER,
    member_State: formData?.MEMBER_STATE,
    observation_Start_Date: formData?.OBSERVATION_START_DATE.split("T")[0],
    observation_End_Date: formData?.OBSERVATION_END_DATE.split("T")[0],
  };  
  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[0].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[0].description}</p>
      <Formik
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          handleChange,
          handleBlur,
          values,
          setFieldValue,
          touched,
          errors,
        }) => (
          <Form >
            <Row className="mb-3">
              <Form.Group className="px-2" as={Col} xs={6} md={4}>
                <Form.Label style={Fontstyling.label}>
                  Date Submitted <Required />
                </Form.Label>
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="date_Submitted"
                  placeholder="Date"
                  value={values.date_Submitted}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={errors.date_Submitted && touched.date_Submitted}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.date_Submitted}
                </Form.Control.Feedback>
              </Form.Group>
              <Col xs={12} md={8} className="px-2">
                <Form.Label style={Fontstyling.label}>
                  Clinical Consultant
                </Form.Label>
                <Row className="gap-3">
                  <Form.Group as={Col}>
                    <Form.Control
                      disabled
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="First Name"
                      name="clinical_Consultant_FirstName"
                      value={values.clinical_Consultant_FirstName}
                      onChange={handleChange}
                      isInvalid={
                        touched.clinical_Consultant_FirstName &&
                        errors.clinical_Consultant_FirstName
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.clinical_Consultant_FirstName}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col}>
                    <Form.Control
                      disabled
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="Last Name"
                      name="clinical_Consultant_LastName"
                      value={values.clinical_Consultant_LastName}
                      onChange={handleChange}
                      isInvalid={
                        touched.clinical_Consultant_LastName &&
                        errors.clinical_Consultant_LastName
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.clinical_Consultant_LastName}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                <Form.Label style={Fontstyling.label}>
                  Client Name <Required />
                </Form.Label>
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="Last Name"
                  name="clinical_Consultant_LastName"
                  value={values.client_Name}
                  onChange={handleChange}
                />
                {/* <AsyncPaginate
                  value={selectedClientvalue || ""}
                  isDisabled
                  styles={{
                    ...clientListDrpDwnStyles,
                    control: (base) => ({
                      ...clientListDrpDwnStyles.control(base),
                      border: `1px solid ${
                        errors.client_Name &&
                        touched.client_Name &&
                        !values.client_Name
                          ? "red"
                          : "lightgrey"
                      }`,
                    }),
                  }}
                  placeholder="Select Client name"
                  onChange={(option) => {
                    const findClient = clientData.find(
                      (item) => item.clientID === option.value
                    );
                    setFieldValue("client_Name", option.label);
                    setFieldValue(
                      "benefit_Point_ID",
                      findClient?.benefit_Point_ID
                    );
                    setSelectedClientValue(option);
                  }}
                  additional={{
                    page: 1,
                  }}
                  isSearchable={true}
                  isOptionDisabled={(e) => e.value === 0}
                />
                {errors.client_Name &&
                  touched.client_Name &&
                  !values.client_Name && (
                    <p className="invalid-feedback d-block">
                      {errors.client_Name}
                    </p>
                  )} */}
              </Form.Group>
              <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                <Form.Label style={Fontstyling.label}>
                  Benefit Point ID
                </Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="0"
                  name="benefit_Point_ID"
                  value={values.benefit_Point_ID}
                  disabled
                />
              </Form.Group>
            </Row>
            <Row className="">
              <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                <Form.Label style={Fontstyling.label}>
                Plan Insights Member ID <Required />
                </Form.Label>
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="Last Name"
                  name="clinical_Consultant_LastName"
                  value={values.cgT_Member_ID}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group className="px-2 mb-3" as={Col} xs={6} lg>
                <Form.Label style={Fontstyling.label}>Member DOB</Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="member_DOB"
                  placeholder="Authorized User"
                  value={values.member_DOB}
                  disabled
                />

              </Form.Group>
              <Form.Group className="px-2 mb-3" as={Col} xs={12} md={6} lg>
                <Form.Label style={Fontstyling.label}>Member Gender</Form.Label>
                <div className="d-flex align-items-center gap-3 ">
                  {["Male", "Female", "Other"].map((item) => (
                    <Form.Check
                      className="gap-2 text-dark"
                      type="radio"
                      value={values.member_Gender}
                      name="member_Gender"
                      readOnly
                      label={
                        <span
                          style={{
                            fontSize: 12,
                            letterSpacing: 0.2,
                            color: "#212529",
                          }}
                        >
                          {item}
                        </span>
                      }
                      onChange={handleChange}
                      checked={values.member_Gender === item[0]}
                      isInvalid={errors.member_Gender && touched.member_Gender}
                      disabled
                    />
                  ))}
                </div>

              </Form.Group>
              <Form.Group className="px-2 mb-3" as={Col} xs={6} lg>
                <Form.Label style={Fontstyling.label}>Member State</Form.Label>
                <Form.Control
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  name="member_State"
                  value={values.member_State}
                  disabled
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                <Form.Label style={Fontstyling.label}>
                  Observation Start Date <Required />
                </Form.Label>
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="observation_Start_Date"
                  placeoholder="Authorized User"
                  value={values.observation_Start_Date}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={
                    errors.observation_Start_Date &&
                    touched.observation_Start_Date
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.observation_Start_Date}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="px-2" as={Col} xs={6} lg={4}>
                <Form.Label style={Fontstyling.label}>
                  Observation End Date <Required />
                </Form.Label>
                <img
                  data-tip="Select start date first"
                  src={require("../../../assets/icon/Question_mark_back.png")}
                  style={{ height: 12, marginLeft: 3 }}
                />
                <ReactTooltip />
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="observation_End_Date"
                  placeholder="Authorized User"
                  value={values.observation_End_Date}
                  min={values.observation_Start_Date}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={
                    errors.observation_End_Date && touched.observation_End_Date
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.observation_End_Date}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
const Form2 = ({ formData }) => {
  const initialValues = {
    is_ICD10_NDC: formData?.IS_ICD10_NDC,
    icD10_NDC_Code: formData?.ICD10_NDC_CODE,
    icD10_NDC_Description: formData?.ICD10_NDC_DESCRIPTION,
    first_Date_of_Service: formData?.FIRST_DATE_OF_SERVICE.split("T")[0],
    last_Date_of_Service: formData?.LAST_DATE_OF_SERVICE.split("T")[0],
  };
  const [selectedICDNCCode, setSelectedICDNCCode] = useState("");
  const [isManual, setIsManual] = useState(true);
  const inpRef = useRef(null);

  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[1].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[1].description}</p>
      <Formik
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          handleChange,
          handleBlur,
          values,
          setFieldValue,
          setFieldError,
          touched,
          errors,
        }) => (
          <Form >
            <Row>
              <Form.Group as={Col} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  ICD-10 or NDC <Required />
                </Form.Label>
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="Last Name"
                  name="clinical_Consultant_LastName"
                  value={values.is_ICD10_NDC}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  ICD-10 / NDC Code <Required />
                </Form.Label>
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="Last Name"
                  name="clinical_Consultant_LastName"
                  value={values.icD10_NDC_Code}
                  onChange={handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  ICD-10 / NDC Description
                </Form.Label>
                <Form.Control
                  disabled
                  ref={inpRef}
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  type="text"
                  placeholder="e.g.,23"
                  name="icD10_NDC_Description"
                  value={values.icD10_NDC_Description}
                  onChange={handleChange}
                  isInvalid={
                    touched.icD10_NDC_Description &&
                    errors.icD10_NDC_Description
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.icD10_NDC_Description}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} xs={6} lg={4} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  First Date of Service <Required />
                </Form.Label>
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="first_Date_of_Service"
                  placeholder="Authorized User"
                  value={values.first_Date_of_Service}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={
                    errors.first_Date_of_Service &&
                    touched.first_Date_of_Service
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.first_Date_of_Service}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} xs={6} lg={4} className="px-2 mb-3">
                <Form.Label style={Fontstyling.label}>
                  Last Date of Service <Required />
                </Form.Label>
                <img
                  data-tip="Select start date first"
                  src={require("../../../assets/icon/Question_mark_back.png")}
                  style={{ height: 12, marginLeft: 3 }}
                />
                <ReactTooltip />
                <Form.Control
                  disabled
                  className="rounded-0 py-1"
                  style={{ ...Fontstyling.label, textTransform: "uppercase" }}
                  type="date"
                  name="last_Date_of_Service"
                  placeholder="Authorized User"
                  value={values.last_Date_of_Service}
                  min={values.first_Date_of_Service}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isInvalid={
                    errors.last_Date_of_Service && touched.last_Date_of_Service
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {errors.last_Date_of_Service}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
const Form3 = ({isPreveiw,formData }) => {
  const initialValues = {
    clinical_Overview_Member_Claim_History: formData?.CLINICAL_OVERVIEW_MEMBER_CLAIM_HISTORY,
  };
  const [tableData, setTableData] = useState([]);
 
  useEffect(() => {
    setTableData(JSON.parse([formData?.MEDICATION_DRUG_USE]))
  }, [])
  
  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[2].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[2].description}</p>
      <Formik
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          handleChange,
          values
        }) => (
          <Form >
            <Row className="mb-3">
              <Form.Group className="mb-3">
                <Form.Label style={Fontstyling.label}>
                  Clinical Overview of Member Claim History:
                </Form.Label>
                <Form.Control
                  as="textarea"
                  className="rounded-0 py-1"
                  style={Fontstyling.label}
                  name="clinical_Overview_Member_Claim_History"
                  onChange={handleChange}
                  value={values.clinical_Overview_Member_Claim_History}
                  rows={3}
                  disabled
                />
              </Form.Group>
              <Form.Label className="mt-2" style={Fontstyling.label}>
                Encounters or Notable Procedures (CPT / HCPCS) or Medication /
                Drug Use
              </Form.Label>
              <Table bordered hover responsive>
                <thead style={Fontstyling.label}>
                  <tr className="text-center align-middle">
                    {[
                      "",
                      "Typical for Dx / Rx",
                      "Atypical for Dx Rx",
                      "Staged",
                      "Orphan Drug",
                      "Off-Label",
                      "Exp/Inv Use",
                    ].map((el, ind) => {
                      if (isPreveiw) return;
                      return <th key={ind}>{el}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, rowInd) => (
                    <Form3TableRow
                      key={rowInd}
                      row={row}
                      rowInd={rowInd}
                      tableData={tableData}
                    />
                  ))}
                </tbody>
              </Table>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
const Form4 = ({ formData}) => {
  const initialValues = {
    treatment_Description: formData?.TREATMENT_DESCRIPTION,
    potential_Complications: formData?.POTENTIAL_COMPLICATIONS,
    clinical_Consultant_Summary: formData?.CLINICAL_CONSULTANT_SUMMARY,
    reference_Links: formData?.REFERENCE_LINKS,
  }
  const [analyticsMedTblData, setAnalyticsMedTblData] = useState([]);
  const [analyticsRxTblData, setAnalyticsRxTblData] = useState([]);
  const [stateData, setStateData] = useState([])
  useEffect(() => {
      setAnalyticsMedTblData(JSON.parse([formData?.TREATMENT_ANALYTICS_MEDICAL]))
      setAnalyticsRxTblData(JSON.parse([formData?.TREATMENT_ANALYTICS_RX]))
  }, [])

  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[3].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[3].description}</p>
      <Formik
        enableReinitialize
        initialValues={initialValues}
      >
        {({
          handleChange,
          values,
        }) => (
          <Form >
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>
                Treatment Description / FDA Approved Indications:
              </Form.Label>
              <Form.Control
                as="textarea"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                name="treatment_Description"
                rows={3}
                onChange={handleChange}
                value={values.treatment_Description}
                disabled
              />
            </Form.Group>
            <Form.Group>
              <Form.Label style={Fontstyling.label}>
                Treatment Analytics Medical:
              </Form.Label>
              <Table bordered hover responsive>
                <thead style={Fontstyling.label}>
                  <tr className="text-center align-middle">
                    {[
                      "",
                      "State",
                      "Observation Cost",
                      "Billed Min",
                      "Billed Max",
                      "Nat'l Min",
                      "Nat'l Max",
                    ].map((el, ind) => {
                      return <th key={ind}>{el}</th>;
                    })}
                  </tr>
                </thead>
                <tbody>
                  {analyticsMedTblData.map((row, rowInd) => (
                    <Form4TAMedTableRow
                      key={rowInd}
                      row={row}
                      rowInd={rowInd}
                      tableData={analyticsMedTblData}
                      stateData={stateData}
                    />
                  ))}
                </tbody>
              </Table>
            </Form.Group>
            <Form.Group>
              <Form.Label style={Fontstyling.label}>
                Treatment Analytics Rx:
              </Form.Label>
              <Table bordered hover responsive>
                <thead style={Fontstyling.label}>
                  <tr className="text-center align-middle">
                    {[
                      "",
                      "Member Type",
                      "Line of Therapy",
                      "Qty Cost Basis",
                      "Observation Cost",
                      "AMS Risk Threshold",
                      "Cost Projection",
                      "Trigger Dx Name",
                    ].map((el, ind) => {
                      return (
                        <th
                          style={{
                            width: `${100 / 8}%`,
                            minWidth: `${100 / 8}%`,
                            maxWidth: `${100 / 8}%`,
                          }}
                          key={ind}
                        >
                          {el}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {analyticsRxTblData.map((row, rowInd) => (
                    <Form4TARxTableRow
                      key={rowInd}
                      row={row}
                      rowInd={rowInd}
                      tableData={analyticsRxTblData}
                    />
                  ))}
                </tbody>
              </Table>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>Potential Complications:</Form.Label>
              <Form.Control
                as="textarea"
                name="potential_Complications"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                rows={3}
                onChange={handleChange}
                value={values.potential_Complications}
                disabled
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                Using AMS criteria and/or criteria based on your license scope
                of practice, provide complications that may arise within this
                diagnosis, future treatments or medication use
              </p>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>Clinical Consultant Summary:</Form.Label>
              <Form.Control
                as="textarea"
                name="clinical_Consultant_Summary"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                rows={3}
                onChange={handleChange}
                value={values.clinical_Consultant_Summary}
                disabled
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                Enter your final assessment of risk, expected cost, prognosis,
                and/or expected outcomes. Please be sure to reference sources
                that fall outside the scope of your licensure or sources used to
                complete your summary below.
              </p>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>Reference Links / Sources:</Form.Label>
              <Form.Control
                as="textarea"
                name="reference_Links"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                rows={3}
                onChange={handleChange}
                value={values.reference_Links}
                disabled
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                If using a source other than AMS, provide source in APA format.
                Format links using https://citefast.com/?s=APA7
              </p>
            </Form.Group>
          </Form>
        )}
      </Formik>
    </>
  );
};
const Form5 = ({ formData,setShowTable,isPreveiw}) => {
  const initialValues = {
    clinical_Prognosis: formData?.CLINICAL_PROGNOSIS,
    clinical_Recommendations: formData?.CLINICAL_RECOMMENDATIONS,
  };
  return (
    <>
      <h3 style={Fontstyling.heading}>{stepHeaders[4].title}</h3>
      <p style={Fontstyling.primaryparagraph}>{stepHeaders[4].description}</p>
      <Formik
        enableReinitialize 
        initialValues={initialValues}
      >
        {({
          handleChange,
          values
        }) => (
          <Form >
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>Clinical Prognosis:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="clinical_Prognosis"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                value={values.clinical_Prognosis}
                onChange={handleChange}
                disabled
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                Enter prognosis based on research data, sources, and body of
                knowledge related to the diagnosis, treatment, medication, etc.
                Please be sure to use referenced sources if the recommendation
                or prognosis falls outside the scope of your licensure.
              </p>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label style={Fontstyling.label}>Clinical Recommendations:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="clinical_Recommendations"
                className="rounded-0 py-1"
                style={Fontstyling.label}
                value={values.clinical_Recommendations}
                onChange={handleChange}
                disabled
              />
              <p className="fw-normal" style={Fontstyling.primaryparagraph}>
                Enter clinical recommendations based on research data, sources,
                and body of knowledge related to the diagnosis, treatment,
                medication, etc. Please be sure to use referenced sources if the
                recommendation or prognosis falls outside the scope of your
                licensure.
              </p>
            </Form.Group>
          </Form>
        )}
      </Formik>
    </>
  );
};

const Form3TableRow = ({
  row,
  rowInd,
  tableData,
  onRowDataSubmit,
  
}) => {

  const {
    id,
    medic_drug_name,
    TypicalDxRx,
    AtypicalDxRx,
    Staged,
    OrphanDrug,
    OffLabel,
    ExpInvUse,
  } = row;

  const initialValues = {
    medic_drug_name: medic_drug_name ?? "",
    TypicalDxRx: TypicalDxRx ? true : false,
    AtypicalDxRx: AtypicalDxRx ? true : false,
    Staged: Staged ? true : false,
    [`radio${rowInd}`]: OrphanDrug
      ? "OrphanDrug"
      : OffLabel
      ? "OffLabel"
      : ExpInvUse
      ? "ExpInvUse"
      : "",
  };


  return (
    <Formik
      key={rowInd}
      enableReinitialize
      onSubmit={(vals, hand) => onRowDataSubmit(vals, hand, rowInd, id)}
      initialValues={initialValues}
    >
      {({
        handleChange,
        values,
        touched,
        errors,
      }) => (
        <tr className={"pe-auto"}>
          <td
          
          >
            <Form.Group>
              <Form.Control
                className="rounded-0 py-1"
                style={{ ...Fontstyling.label, minWidth: "70px" }}
                type="text"
                placeholder="e.g.,23"
                name="medic_drug_name"
                onChange={(e) => {
                  handleChange(e);
                }}
                value={values.medic_drug_name}
                isInvalid={touched.medic_drug_name && errors.medic_drug_name}
                disabled
              />
              <Form.Control.Feedback type="invalid">
              </Form.Control.Feedback>
            </Form.Group>
          </td>
          <td
          
          >
            <Form.Group>
              <Form.Check
                className="d-flex align-items-center justify-content-center"
                name="TypicalDxRx"
                type="checkbox"
                label=""
                onChange={(e) => {
                  handleChange(e);
                }}
                checked={values.TypicalDxRx}
                isInvalid={touched.TypicalDxRx && errors.TypicalDxRx}
                disabled
              />
            </Form.Group>
          </td>
          <td
          
          >
            <Form.Group>
              <Form.Check
                className="d-flex align-items-center justify-content-center"
                name="AtypicalDxRx"
                type="checkbox"
                label=""
                onChange={(e) => {
                  handleChange(e);
                }}
                checked={values.AtypicalDxRx}
                isInvalid={touched.AtypicalDxRx && errors.AtypicalDxRx}
                disabled
              />
            </Form.Group>
          </td>
          <td
          
          >
            <Form.Group>
              <Form.Check
                className="d-flex align-items-center justify-content-center"
                name="Staged"
                type="checkbox"
                label=""
                onChange={(e) => {
                  handleChange(e);
                }}
                checked={values.Staged}
                isInvalid={touched.Staged && errors.Staged}
                disabled
              />
            </Form.Group>
          </td>
          <td
          
          >
            <Form.Check
              className="d-flex align-items-center justify-content-center"
              type="radio"
              name={`radio${rowInd}`}
              value="OrphanDrug"
              onChange={(e) => {
                handleChange(e);
              }}
              checked={values[`radio${rowInd}`] === "OrphanDrug"}
              isInvalid={errors[`radio${rowInd}`] && touched[`radio${rowInd}`]}
              disabled
            />
          </td>
          <td
          
          >
            <Form.Check
              className="d-flex align-items-center justify-content-center"
              type="radio"
              name={`radio${rowInd}`}
              value="OffLabel"
              onChange={(e) => {
                handleChange(e);
              }}
              checked={values[`radio${rowInd}`] === "OffLabel"}
              isInvalid={errors[`radio${rowInd}`] && touched[`radio${rowInd}`]}
              disabled
            />
          </td>
          <td
          
          >
            <Form.Check
              className="d-flex align-items-center justify-content-center"
              type="radio"
              name={`radio${rowInd}`}
              value="ExpInvUse"
              onChange={(e) => {
                handleChange(e);
              }}
              checked={values[`radio${rowInd}`] === "ExpInvUse"}
              isInvalid={errors[`radio${rowInd}`] && touched[`radio${rowInd}`]}
              disabled
            />
          </td>
         
        </tr>
      )}
    </Formik>
  );
};

const Form4TAMedTableRow = ({
  row,
  rowInd,
  tableData,
  onRowDataSubmit,
  stateData,
}) => {
  const {
    id,
    TAMedName,
    State,
    ObservationCost,
    BilledMin,
    BilledMax,
    NatlMin,
    NatlMax,
  } = row;

  const initialValues = {
    TAMedName: TAMedName ?? "",
    State: State ?? "",
    ObservationCost: ObservationCost ?? "",
    BilledMin: BilledMin ?? "",
    BilledMax: BilledMax ?? "",
    NatlMin: NatlMin ?? "",
    NatlMax: NatlMax ?? "",
  };

  return (
    <Formik
      key={rowInd}
      enableReinitialize
      onSubmit={(vals, hand) => onRowDataSubmit(vals, hand, id, "TAMed")}
      initialValues={initialValues}
    >
      {({
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <tr className={"pe-auto"}>
          {Object.keys(initialValues).map((k_name, k_i) => {
            if (k_i === 1) {
              return (
                <td
                  key={k_i}
                  style={{
                    width: `${100 / 8}%`,
                    minWidth: `${100 / 8}%`,
                    maxWidth: `${100 / 8}%`,
                  }}
                  xs={6}
                  lg
                  disabled
                >
                  <Form.Group>
                    <Form.Control
                      disabled
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="Last Name"
                      name="clinical_Consultant_LastName"
                      value={values.State}
                      onChange={handleChange}
                    />
                   
                  </Form.Group>
                </td>
              );
            } else {
              return (
                <td
                  key={k_i}
                  style={{
                    width: `${100 / 8}%`,
                    minWidth: `${100 / 8}%`,
                    maxWidth: `${100 / 8}%`,
                  }}
                  disabled
                >
                  <Form.Group>
                    <Form.Control
                      className="rounded-0 py-1 text-nowrap"
                      style={{ ...Fontstyling.label, minWidth: "70px" }}
                      type={
                        k_name === "ObservationCost" ||
                        k_name === "BilledMin" ||
                        k_name === "BilledMax"
                          ? "number"
                          : "text"
                      }
                      name={k_name}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={values[k_name]}
                      isInvalid={
                        k_name === "TAMedName"
                          ? touched[k_name] && errors[k_name]
                          : false
                      }
                      disabled
                    />
                  </Form.Group>
                </td>
              );
            }
          })}
         
        </tr>
      )}
    </Formik>
  );
};

const Form4TARxTableRow = ({
  row,
  rowInd,
  tableData,
  onRowDataSubmit,
}) => {
  const {
    id,
    TARxName,
    MemberType,
    LineTherapy,
    QtyCostBasis,
    ObservationCost,
    AMSRiskThreshold,
    CostProjection,
    TriggerDxName,
  } = row;
  const tblSchema = yup.object().shape({
    TARxName: yup
      .string()
      .required("required")
      .trim("The contact name cannot include leading and trailing spaces"),
  });

  const initialValues = {
    TARxName: TARxName ?? "",
    MemberType: MemberType ?? "",
    LineTherapy: LineTherapy ?? "",
    QtyCostBasis: QtyCostBasis ?? "",
    ObservationCost: ObservationCost ?? "",
    AMSRiskThreshold: AMSRiskThreshold ?? "",
    CostProjection: CostProjection ?? "",
    TriggerDxName: TriggerDxName ?? "",
  };


  return (
    <Formik
      key={rowInd}
      enableReinitialize
      validationSchema={tblSchema}
      onSubmit={(vals, hand) => onRowDataSubmit(vals, hand, id, "TARx")}
      initialValues={initialValues}
    >
      {({
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <tr className={"pe-auto"}>
          {Object.keys(initialValues).map((k_name, k_i) => {
            if (k_i === 1) {
              return (
                <td
                  key={k_i}
                  style={{
                    width: `${100 / 8}%`,
                    minWidth: `${100 / 8}%`,
                    maxWidth: `${100 / 8}%`,
                  }}
                  xs={6}
                  lg
                >
                  <Form.Group>
                  <Form.Control
                      disabled
                      className="rounded-0 py-1"
                      style={Fontstyling.label}
                      type="text"
                      placeholder="Last Name"
                      name="clinical_Consultant_LastName"
                      value={values.MemberType}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </td>
              );
            } else {
              return (
                <td
                  key={k_i}
                  xs={6}
                  lg
                >
                  <Form.Group>
                    <Form.Control
                      className="rounded-0 py-1"
                      style={{ ...Fontstyling.label, minWidth: "70px" }}
                      type={k_name === "ObservationCost" ? "number" : "text"}
                      name={k_name}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      value={values[k_name]}
                      isInvalid={
                        k_name === "TARxName"
                          ? touched[k_name] && errors[k_name]
                          : false
                      }
                      disabled
                    />
                  </Form.Group>
                </td>
              );
            }
          })}
         
        </tr>
      )}
    </Formik>
  );
};
